import { StarIcon } from '@heroicons/react/20/solid';
import { useEffect, useState } from 'react';

const reviews = [
	{
		name: 'Prince Zu',
		rating: 5,
		review: [
			'I was very impressed with Lumina Solar! Very positive experience and I’ll strongly recommend them to anyone looking to switch to solar. Gabriel the sales agent was knowledgeable, professional, respectful, and answered all our questions satisfactorily! He got all our paperwork done in a timely manner and installation was done in record time! Unlike other sales agents who “disappear” after earning your business, Gabriel is on hand to answer any questions we have from time to time regarding our system! He got married and even sent me a picture of he and his bride. Our energy bill has gone from $250- 300 to about $40!',
		],
		link: 'https://www.google.com/maps/reviews/@39.2526538,-76.6743209,17z/data=!3m1!4b1!4m6!14m5!1m4!2m3!1sChZDSUhNMG9nS0VJQ0FnSUNKLTVhRFVnEAE!2m1!1s0x0:0x25ac710b277bb031?hl=en-US&entry=ttu',
	},
	{
		name: 'D M',
		rating: 5,
		review: [
			`We recently completed our install with Lumina.  I can say that this is one of the best experiences I have ever had with a contractor for a project like this.  From start to finish, Lumina was VERY pleasant to work with.  Gabriel, our sales rep, was straight forward and informative, but without being pushy.  They listened to our needs and tailored the process to accommodate what we were looking for.  In the end, I got the distinct impression that they had no interest in jamming anything “down our throats” and were committed to making sure we were satisfied with what was being done.`,
			`Their pricing was very transparent and straight forward (this was NOT the case with other companies we spoke with), and they clearly explained all the payment options available and the impact on the cost analysis of the project. With the current federal tax credits, this project, for our family, was a no brainer.`,

			`I highly recommend this company!`,
		],
		link: 'https://www.google.com/maps/reviews/@39.2526538,-76.6743209,17z/data=!3m1!4b1!4m6!14m5!1m4!2m3!1sChdDSUhNMG9nS0VJQ0FnSUNaa3EyNjJRRRAB!2m1!1s0x0:0x25ac710b277bb031?hl=en-US&entry=ttu',
	},
	{
		name: 'Tim Baker',
		rating: 5,
		review: [
			`I had a great experience with my recent solar installation by Lumina Solar. Everyone involved was knowledgable and helpful, particularly my solar consultant Gabriel Shabtai.  I have done a lot of home improvement projects over the years and this one stands out.  Great communication, prompt scheduling and flawless execution - five stars.`,
		],
		link: 'https://www.google.com/maps/reviews/@39.2526538,-76.6743209,17z/data=!3m1!4b1!4m6!14m5!1m4!2m3!1sChdDSUhNMG9nS0VJQ0FnSURwMk5UdGlRRRAB!2m1!1s0x0:0x25ac710b277bb031?hl=en-US&entry=ttu',
	},
	{
		name: 'Laurie Dickerson',
		rating: 5,
		review: [
			`The Solar World was new to us and we had lots of questions. We met Gabriel Shabtai through Lumina Solar. He created several designs and was very knowledgeable and patient with all our questions. He possesses the social wisdom to allow people space to process information but also very timely with follow up. I highly recommend Gabriel for your solar needs.`,
		],
		link: 'https://www.google.com/maps/reviews/@39.2526538,-76.6743209,17z/data=!3m1!4b1!4m6!14m5!1m4!2m3!1sChZDSUhNMG9nS0VJQ0FnSUNwNTd5WUVBEAE!2m1!1s0x0:0x25ac710b277bb031?hl=en-US&entry=ttu',
	},
];

export default function Testimonials() {
	const [reviewIdx, setReviewIdx] = useState(0);

	const pickRandomReview = () => {
		setReviewIdx(Math.floor(Math.random() * reviews.length));
	};
	useEffect(() => {
		pickRandomReview();
	}, []);

	return (
		<section className='bg-surface px-6 py-24 sm:py-32 lg:px-8'>
			<div className='mx-auto max-w-3xl text-center mb-12'>
				<p className='text-xs font-semibold uppercase tracking-[0.18em] text-primary-600'>
					<span className='inline-block w-8 h-px align-middle mr-3 bg-current opacity-60' />
					Reviews
				</p>
				<h2 className='font-display mt-4 text-4xl font-medium tracking-tight text-ink-900 sm:text-5xl leading-tight'>
					What clients{' '}
					<span className='italic text-primary-600'>actually</span> say.
				</h2>
			</div>
			<figure className='mx-auto max-w-3xl sg-card bg-white p-10 sm:p-14 relative'>
				<svg
					className='absolute top-8 right-10 h-12 w-12 text-primary-100'
					viewBox='0 0 32 32'
					aria-hidden='true'
					fill='currentColor'
				>
					<path d='M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z' />
				</svg>
				<div className='flex items-center justify-between'>
					<p className='sr-only'>5 out of 5 stars</p>
					<div className='flex gap-x-0.5 text-primary-500'>
						{reviewIdx !== null &&
							Array.from({ length: reviews[reviewIdx].rating || 5 }).map(
								(_, i) => (
									<StarIcon
										key={i}
										className='h-5 w-5 flex-none'
										aria-hidden='true'
									/>
								)
							)}
					</div>
					<button
						onClick={pickRandomReview}
						className='rounded-full bg-ink-100 px-4 py-1.5 text-xs font-semibold text-ink-700 hover:bg-ink-200 transition-colors'
					>
						Next review →
					</button>
				</div>
				<blockquote className='font-display mt-8 text-xl leading-relaxed text-ink-800 sm:text-2xl sm:leading-relaxed'>
					{reviewIdx !== null &&
						reviews[reviewIdx].review.map((r, i) => (
							<p key={i} className='mt-4 first:mt-0'>
								&ldquo;{r}&rdquo;
							</p>
						))}
				</blockquote>
				<figcaption className='mt-10 pt-6 border-t border-ink-100 flex items-center gap-x-4'>
					<div className='h-11 w-11 rounded-full bg-primary-500 text-white font-medium font-display flex items-center justify-center text-lg'>
						{reviewIdx !== null &&
							reviews[reviewIdx].name.charAt(0).toUpperCase()}
					</div>
					<div className='text-sm leading-6'>
						<div className='font-semibold text-ink-900'>
							{reviewIdx !== null && reviews[reviewIdx].name}
						</div>
						<a
							target='_blank'
							rel='noreferrer'
							href={reviewIdx !== null ? reviews[reviewIdx].link : '#'}
							className='text-primary-600 hover:text-primary-700 transition-colors text-xs'
						>
							Read on Google →
						</a>
					</div>
				</figcaption>
			</figure>
		</section>
	);
}
